import { Typography } from "@mui/material";
import { Attachment as AttachmentIcon } from "@mui/icons-material";
import { FileWithPath } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";

export function AcceptedFiles(props: { acceptedFiles: FileWithPath[] }) {
  const { acceptedFiles } = props;
  const { t } = useTranslation();

  return render();

  function render() {
    if (!acceptedFiles || acceptedFiles.length === 0) return null;

    return (
      <Styles>
        <Typography variant="h5">{t("label.acceptedFiles")}</Typography>

        <ul>
          {acceptedFiles.map((acceptedFile: FileWithPath, i) => (
            <li key={i}>
              <AttachmentIcon className="icon" />
              {acceptedFile.path} - {acceptedFile.size} {t("label.bytes")}
            </li>
          ))}
        </ul>
      </Styles>
    );
  }
}

const Styles = styled("div")`
  padding: ${({ theme }) => theme.spacing(3, 0)};
  color: ${({ theme }) => theme.palette.text.primary};

  ul {
    padding: 0;

    li {
      display: flex;
      gap: 10px;

      &:not(:first-child) {
        padding-top: ${({ theme }) => theme.spacing(1)};
      }

      .icon {
        transform: translateY(-2px);
      }
    }
  }
`;
